!<template>
    <div>
        <div class="middle">
            <a href="https://wulvxinchen.cn/">
                <img :src="logosrc" width="200px">
            </a>
            <br>
            <el-input v-model="seach" 
            placeholder="请输入搜索内容"
            @keyup.enter.native="seachBy"
            style="width:60em">
            </el-input>
            <el-button 
            type="primary"
            icon="el-icon-search" 
            circle
            @click="seachBy"
            style="margin-left:1em"></el-button>
            <el-dropdown 
            size="medium" 
            split-button 
            type="primary"
            class="selectSeach"
            @command="changeSearch">
                选择引擎:{{seachitem.name}}
            <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="0">百度</el-dropdown-item>
                    <el-dropdown-item command="1">谷歌</el-dropdown-item>
                    <el-dropdown-item command="2">必应</el-dropdown-item>
                    <el-dropdown-item command="3">搜狗</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        
    </div>
</template>

<script>
export default {
    name:'MySeach',
    data(){
        return{
            seachitem:{name:'百度',url:'https://www.baidu.com/s?wd='},
            seach:'',
            logosrc:'./img/Logo.png',
            seachList:[
                {name:'百度',url:'https://www.baidu.com/s?wd='},
                {name:'谷歌',url:'https://www.google.com/search?q='},
                {name:'必应',url:'https://cn.bing.com/search?q='},
                {name:'搜狗',url:'https://www.sogou.com/web?query='},
            ],
        }
    },
    methods:{
        seachBy(){
            if(this.seach!=''){
                location.href = (this.seachitem.url+this.seach)
            }
            else{
                this.$message({
                    message: '输入为空',
                    type: 'warning'
                });
            }
        },
        changeSearch(item){
            this.seachitem=this.seachList[item]
        },
    },
}
</script>

<style>
    .middle{
        margin: 0em auto;
    }
    .selectSeach{
        margin: 0em 0em 0em 1em;
    }
</style>